export const categoryMap: Record<string, string> = {
  tax: "Tax",
  loans: "Loans",
  retirement: "Retirement",
  investments: "Investments",
  savings: "Savings & Budget",
  budgeting: "Budgeting",
  glossary: "Glossary",
};

export const categoryDescriptionMap: Record<string, string> = {
  tax: "Calculate income tax, capital gains, self-employment tax, and other tax obligations with our country-specific calculators.",
  loans: "Estimate mortgage payments, loan affordability, refinancing benefits, and debt payoff strategies with accurate loan calculators.",
  retirement: "Plan your retirement with calculators for retirement savings, withdrawal rates, pension estimates, and FIRE planning.",
  investments: "Model investment returns, compound interest growth, dividend income, and dollar-cost averaging strategies.",
  savings: "Calculate emergency fund targets, savings goals, inflation impact, and real returns on your savings.",
  budgeting: "Plan and track your budget with tools for the 50/30/20 rule, debt-to-income ratios, and net worth calculations.",
};

export const calculatorNameMap: Record<string, string> = {
  "inflation-impact": "Inflation Impact Calculator",
  "no-tax-on-tips": "No Tax on Tips Calculator",
  "no-tax-on-overtime": "No Tax on Overtime Calculator",
  "senior-deduction": "Senior Deduction Calculator",
  "auto-loan-interest-deduction": "Auto Loan Interest Deduction Calculator",
  "obbba-total-savings": "OBBBA Total Savings Calculator",
  "trump-account-growth": "Trump Account Growth Calculator",
  "401k-contribution-calculator-2026": "401(k) Contribution Maximizer (2026)",
  "irs-mileage-rate-calculator-2026": "IRS Mileage Rate Split Calculator (2026)",
  "irs-penalty-relief-aep": "IRS Penalty Relief & AEP Calculator",
  "va-partial-claim-estimator": "VA Partial Claim Estimator",
  "student-loan-save-transition-calculator-2026": "Student Loan SAVE Transition Calculator",
  "irs-afr-intra-family-loan-calculator-august-2026": "IRS AFR Intra-Family Loan Calculator",
  "instant-deduction": "Instant Tax Deduction Calculator",
  "fair-work-minimum-wage-increase-calculator-july-2026": "Fair Work Minimum Wage Calculator (July 2026)",
  "stage-3-tax-cut-15-percent-bracket-calculator-2026": "Stage 3 Tax Cut Calculator (2026)",
  "whm-tax-take-home-calculator": "Working Holiday Maker Tax Calculator",
  "apra-dti-cap-check": "APRA DTI Cap Check",
  "offset-error-cost-calculator": "Offset Account Error Cost Calculator",
  "capital-one-360-settlement-payout-estimator": "Capital One 360 Settlement Payout Estimator",
  "payday-super-impact": "Payday Super Impact Calculator",
  "payday-super-compliance": "Payday Super Compliance Calculator",
  "osfi-mortgage-stress-test-exemption-switch-calculator-2026": "OSFI Mortgage Stress Test Calculator",
  "new-home-gst-rebate": "New Home GST/HST Relief Calculator",
  "cpf-retirement-age-transition-calculator-2026": "CPF Retirement Age Shift Simulator",
  "budget-2026-cpf-top-up-checker": "Budget 2026 CPF Top-Up Checker",
  "ssb-calculator": "Singapore Savings Bonds (SSB) Calculator",
  "hra-exemption-calculator-8-cities": "8-City HRA Exemption Calculator",
  "lrs-tcs-calculator": "LRS TCS Calculator (Budget 2026)",
  "ups-pension-estimator": "UPS Pension Estimator",
  "rbi-mis-selling-compensation-calculator-2026": "RBI Mis-Selling Compensation Calculator",
  "new-labour-codes-ctc-restructuring-calculator": "India Labour Codes Wage Base and PF Checker",
  "fma-cccfa-complaint-eligibility-checker-july-2026": "NZ FMA CCCFA Complaint Checker",
  "compulsory-kiwisaver-impact": "KiwiSaver Rate and Paycheck Scenario Calculator",
  "overseas-student-loan-repayment-calculator": "Overseas Student Loan Repayment Calculator",
  "nz-fees-free-2026-completion-cutoff-calculator": "NZ Fees Free Cutoff Calculator",
  "au-pension-supplement-overseas-12-week-calculator": "Overseas Pension Supplement Calculator",
  "california-ab1847-wildfire-forbearance-planner": "CA Wildfire Forbearance Planner",
  "aktivrente-tax-savings": "Aktivrente Tax Savings Calculator",
  "fruehstart-rente-growth": "Fruehstart-Rente Growth Projector",
  "altersvorsorgedepot-calculator-2027": "Altersvorsorgedepot Calculator (2027)",
  "kvdr-9-10-rule-eligibility-calculator": "KVdR 9/10 Rule Eligibility Calculator",
  "cash-isa-2027-cap-impact": "Cash ISA 2027 Cap Impact Calculator",
  "uk-bnpl-dpc-rights": "UK BNPL Consumer Rights Simulator",
  "13th-ahv-pension-calculator-2026": "13th AHV Pension Calculator",
  "pillar-3a-retroactive-buy-in": "Pillar 3a Retroactive Buy-In Calculator",
  "box3-wealth-tax": "Box 3 Wealth Tax Calculator",
  "zzp-tax-deduction-take-home-calculator": "ZZP Tax Deduction & Take-Home Calculator",
};
